import { resolveAssetUrl } from "@/utils/media";

export const DEFAULT_HERO_SLIDES = [
  {
    image: "/premium_brake_assembly_hero.png",
    title: "Brake Systems",
    caption: "Performance-grade braking visuals with a clean product-first feel.",
  },
  {
    image:
      "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?q=80&w=1600&auto=format&fit=crop",
    title: "Workshop Ready",
    caption: "A fast, reliable look for garages and fitment-heavy browsing.",
  },
  {
    image:
      "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=1600&auto=format&fit=crop",
    title: "Reliable Components",
    caption: "Use real automotive photography to keep the hero grounded.",
  },
];

export const normalizeHeroSlides = (slides = []) => {
  const provided = Array.isArray(slides) ? slides : [];
  if (!provided.length) {
    return DEFAULT_HERO_SLIDES;
  }

  return provided
    .map((slide, index) => {
      const fallback = DEFAULT_HERO_SLIDES[index % DEFAULT_HERO_SLIDES.length] || DEFAULT_HERO_SLIDES[0];
      const image = resolveAssetUrl(
        slide?.image ||
          slide?.imageUrl ||
          fallback?.image ||
          DEFAULT_HERO_SLIDES[0]?.image,
      );

      return {
        image,
        title: slide?.title || fallback?.title || "",
        caption: slide?.caption || slide?.description || fallback?.caption || "",
        alt: slide?.alt || fallback?.title || "Hero slide",
      };
    })
    .filter((slide) => Boolean(slide.image));
};
